import { Button } from "@mantine/core";
import React from "react";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  Row,
  Cell,
} from "react-table";
import { ArrowIcon } from "../../assets/svgs";

type Props = {
  data: any;
  columns: any;
};

const Table: React.FC<Props> = ({ data, columns }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    gotoPage,
    pageOptions,
    state,
    prepareRow,
  }: any = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 16 } as any,
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
  );

  const { pageIndex } = state;

  return (
    <>
      <div className="table-wrapper table-auto">
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup: any) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column: any) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    <span style={{ marginLeft: 7 }}>
                      <span
                        style={{
                          display: "inline-block",
                          transition: "0.2s transform ease-in-out",
                          transform: column.isSortedDesc
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      >
                        <ArrowIcon hide={!column.isSorted} strokeWidth={2} />
                      </span>
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row: Row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell: Cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="table-pagination">
        <div className="table-pagination__button-group">
          {pageOptions.map((_: any, index: number) => {
            return (
              <Button
                key={index}
                onClick={() => gotoPage(index)}
                disabled={index === pageIndex}
                style={{
                  paddingLeft: 18,
                  paddingRight: 18,
                  cursor: index === pageIndex ? "default" : "pointer",
                }}
                type="button"
              >
                {index + 1}
              </Button>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Table;
